import React, { useEffect, useState } from 'react';
import { useFeeCodes, FEE_CODES_CACHE_KEY } from '../../../services/api/catalogService';

/**
 * Component to fetch fee codes from API and provide them to the NewEvaluationDialog
 */
const FeeCodeProvider = ({ onFeeCodesLoaded }) => {
  const { data: feeCodes, isLoading, error } = useFeeCodes();
  const [loaded, setLoaded] = useState(false);

  // Hydrate from localStorage immediately (offline or slow network)
  useEffect(() => {
    if (!loaded && typeof window !== 'undefined') {
      try {
        const raw = window.localStorage.getItem(FEE_CODES_CACHE_KEY);
        if (raw) {
          const parsed = JSON.parse(raw);
          const codes = Array.isArray(parsed)
            ? parsed
                .map((fee) => (typeof fee === 'string' ? fee : fee?.code))
                .filter(Boolean)
            : [];
          if (codes.length) {
            onFeeCodesLoaded(codes);
            setLoaded(true);
          }
        }
      } catch (e) {
        console.warn('Failed to read cached fee codes:', e);
      }
    }
  }, [loaded, onFeeCodesLoaded]);

  useEffect(() => {
    if (!isLoading && !loaded && feeCodes) {
      // Extract just the code values from the fee codes
      const feeCodeOptions = feeCodes
        .map((fee) => (typeof fee === 'string' ? fee : fee?.code))
        .filter(Boolean);
      onFeeCodesLoaded(feeCodeOptions);
      setLoaded(true);
    }
  }, [feeCodes, isLoading, loaded, onFeeCodesLoaded]);

  // This component doesn't render anything
  return null;
};

export default FeeCodeProvider;